/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LensSpecification from './lens-specification';
import LensSpecificationDetail from './lens-specification-detail';
import LensSpecificationUpdate from './lens-specification-update';
import LensSpecificationDeleteDialog from './lens-specification-delete-dialog';

const LensSpecificationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LensSpecification />} />
    <Route path="new" element={<LensSpecificationUpdate />} />
    <Route path=":id">
      <Route index element={<LensSpecificationDetail />} />
      <Route path="edit" element={<LensSpecificationUpdate />} />
      <Route path="delete" element={<LensSpecificationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LensSpecificationRoutes;
